export default "__VITE_ASSET__DnzWgeO3__"